// removed by extract-text-webpack-plugin
module.exports = {"stones-section":"_15e9KI_i","stonesSection":"_15e9KI_i","content":"_3p4LY9qY","title":"_2ltZUqY0","learn-more":"_3fjjzpBn","learnMore":"_3fjjzpBn","button":"_2F62EIHx","img":"_1G5clbOn","wrap":"ilzz-e88"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StonesSection/StonesSection.pcss
// module id = 401
// module chunks = 0